export default "__VITE_ASSET__9Q2$Y7qU__"